var _dec, _class;
import { Injectable } from "../inject/index.js";
import { ObservableValue } from "../observable-value.js";
/**
 * A context service to get/set the active notification message
 */
export let NotificationService = (_dec = Injectable({
  lifetime: 'singleton'
}), _dec(_class = class NotificationService {
  constructor() {
    this.activeMessages = new ObservableValue([]);
  }
  add(newMessage) {
    this.activeMessages.setValue([...this.activeMessages.getValue().filter(message => message.level !== newMessage.level), newMessage]);
  }
  dismiss(oldItem) {
    this.activeMessages.setValue([...this.activeMessages.getValue()].filter(message => message && JSON.stringify(message) !== JSON.stringify(oldItem)));
  }
}) || _class);
//# sourceMappingURL=notification-service.js.map